import {
	GlobalFooter,
	type CustomSection,
	type SocialLinkItem,
} from '@ds-mgnl/marketing';
import { type ImageProps } from '@dsx/react';
import footerLogo from '../../assets/images/ds-logo-color.svg';

export const Footer = () => {
	const logo: ImageProps = {
		src: footerLogo,
		alt: 'Direct Supply Logo',
	};

	const socialLinks: SocialLinkItem[] = [
		{
			href: 'https://www.facebook.com/directsupply',
			site: 'facebook',
		},
		{
			href: 'https://twitter.com/_DirectSupply',
			site: 'twitterX',
		},
		{
			href: 'http://www.linkedin.com/company/direct-supply',
			site: 'linkedin',
		},
		{
			href: 'http://www.youtube.com/c/directsupply',
			site: 'youtube',
		},
	];

	const customSections: CustomSection[] = [
		{
			section: {
				title: 'TELS',
			},
			linkGroups: [
				{
					title: 'Solutions',
					links: [
						{
							href: '/solutions/labor-efficiency',
							children: 'Labor Efficiency',
						},
						{
							href: '/solutions/compliance',
							children: 'Compliance',
						},
						{
							href: '/solutions/capital-management',
							children: 'Capital Management',
						},
						{
							href: '/services/routine-and-emergency-repairs',
							children: 'Routine & Emergency Repairs',
						},
						{
							href: '/services/recurring-maintenance-programs',
							children: 'Recurring Maintenance Programs',
						},
						{
							href: '/services/planned-projects',
							children: 'Planned Projects',
						},
					],
				},
				{
					title: 'Products',
					links: [
						{
							href: '/products/tels-platform',
							children: 'TELS Platform',
						},
						{
							href: '/products/maintenance',
							children: 'Maintenance',
						},
						{
							href: '/products/housekeeping',
							children: 'Housekeeping',
						},
						{
							href: '/services',
							children: 'TELS Building Services',
						},
						{
							href: '/products/third-party-integrations',
							children: 'Third Party Integrations',
						},
					],
				},
				{
					title: 'Resources',
					links: [
						{ href: '/resources/blogs', children: 'Expertise' },
						{ href: '/resources/case-studies', children: 'Case Studies' },
						{
							href: '/resources/regulatory-guides',
							children: 'Regulatory Guides',
						},
						{ href: '/resources', children: 'All Resources' },
					],
				},
			],
		},
	];

	return (
		<GlobalFooter
			logo={logo}
			socialLinks={socialLinks}
			customSections={customSections}
		/>
	);
};
